/**
 * no-ruff-supply.js
 *
 * Two-step weight × supply selector for NO RUFF (single-SKU model).
 *
 * The customer always buys the 200 ml variant; the chosen weight × duration
 * tile sets the quantity on the buy-button form. Shopify automatic discounts
 * (qty ≥ N, one per tier) deliver the per-bottle price at checkout.
 *
 * --- SOURCE-OF-TRUTH NOTE ---
 * PRICE_BY_QTY below must mirror the 6 Shopify automatic discounts
 * (titles: "No Ruff · Buy N bottles · X% off"). If those drift, update
 * both. The Jest test theme-jollygut-noruff-selector.test.js asserts the
 * code-side values; live drift is caught by manual QA only.
 *
 * Dose chart (on-pack, once daily, 1 pump = 1.25 ml, 200 ml bottle):
 *   ≤10 kg  → 2 pumps/day → 80-day bottle
 *   10–20 kg → 4 pumps/day → 40-day bottle
 *   20–40 kg → 5 pumps/day → 32-day bottle (chart rounds to 30)
 *   >40 kg  → 6 pumps/day → 27-day bottle (chart rounds to 25)
 */

(function () {
  // A missing engine would otherwise throw a bare TypeError.
  if (!window.UwPackPlan) {
    console.error(
      "[pack-plan] uw-pack-plan.js must load before no-ruff-supply.js",
    );
    return;
  }

  const PUMPS_PER_DAY_BY_WEIGHT = {
    small: 2,
    medium: 4,
    large: 5,
    xlarge: 6,
  };

  // (weight, tile index) → bottles shipped + marketing duration label.
  // Starter is qty=1 for small + medium dogs (₹799 entry), qty=2 for large
  // dogs (₹1,499), qty=3 for giant dogs (₹2,049) — three distinct entry
  // prices that reflect how many bottles each size actually needs.
  // Duration labels round down from real days at chart dose so the customer
  // never runs short. Most Popular and Most Savings ladder up to 120 / 180
  // day labels across the bigger dogs.
  const SUPPLY_BY_WEIGHT_AND_TILE = {
    small: [
      { qty: 1, days: 60 },
      { qty: 2, days: 120 },
      { qty: 3, days: 240 },
    ],
    medium: [
      { qty: 1, days: 40 },
      { qty: 3, days: 120 },
      { qty: 5, days: 180 },
    ],
    large: [
      { qty: 2, days: 60 },
      { qty: 4, days: 120 },
      { qty: 6, days: 180 },
    ],
    xlarge: [
      { qty: 3, days: 75 },
      { qty: 5, days: 120 },
      { qty: 7, days: 180 },
    ],
  };

  // Discounted total price per bottle count (matches the 6 Shopify auto-discounts).
  const PRICE_BY_QTY = {
    1: 799,
    2: 1499,
    3: 2049,
    4: 2499,
    5: 3049,
    6: 3599,
    7: 4199,
  };

  const BASE_PRICE_PER_BOTTLE = 799;
  const MRP_PER_BOTTLE = 849;
  // "No Ruff · Buy 7 bottles · 24.9% off" applies to 8+ bottles too.
  const TOP_TIER_DISCOUNT = 0.249;

  window.UwPackPlan.define("no-ruff-two-step", {
    key: "no-ruff",
    unit: "200 ml",
    noun: "pet",
    propertyName: "Pet",
    SUPPLY_BY_WEIGHT_AND_TILE,
    PRICE_BY_QTY,
    BASE_PRICE_PER_BOTTLE,
    MRP_PER_BOTTLE,
    TOP_TIER_DISCOUNT,
    dose: (weight) => {
      const pumps = PUMPS_PER_DAY_BY_WEIGHT[weight];
      return pumps === 1 ? "1 pump" : `${pumps} pumps`;
    },
  });
})();
